import React, { useRef, useState } from 'react';
import classNames from 'classnames';
export var MessageCollapse = function (_a) {
    var children = _a.children, isClosed = _a.isClosed;
    var _b = useState(false), isHidden = _b[0], setIsHidden = _b[1];
    var container = useRef(null);
    return (React.createElement("div", { ref: container, hidden: isHidden, className: classNames('ffe-message-collapse', {
            'ffe-message-collapse--closed': isClosed,
        }), onTransitionEnd: function (e) {
            if (e.target === container.current) {
                setIsHidden(true);
            }
        } },
        React.createElement("div", { className: "ffe-message-collapse__inner" }, children)));
};
